import api from 'aio-api'

function arrayToMap (requests) {
  return requests.reduce(
    (obj, r) => ({...obj, [r.id]: r}),
    {},
  )
}

function sortRequests (requestA, requestB) {
  if (requestA.created < requestB.created) return 1
  else if (requestA.created > requestB.created) return -1
  else return 0
}

export default {
  namespaced: true,
  state: {
    made: {},
    managed: {
      processed: {},
      pending: {},
    },
  },
  actions: {
    fetchOwn: async ({commit, rootGetters}) => {
      if (rootGetters.currentUserId) {
        const requests = await api.getRequests(rootGetters.currentUserId)
        commit('setMade', requests)
      }
    },
    fetchProcessed: async ({commit, rootGetters}) => {
      if (rootGetters.currentUserId) {
        const requests = await api.getProcessedRequests(rootGetters.currentUserId)
        commit('setProcessed', requests)
      }
    },
    fetchPending: async ({commit, rootGetters}) => {
      if (rootGetters.currentUserId) {
        const requests = await api.getPendingRequests(rootGetters.currentUserId)
        commit('setPending', requests)
      }
    },
    fetchManaged: async ({dispatch}) => {
      await dispatch('fetchProcessed')
      await dispatch('fetchPending')
    },
    fetchAll: async ({dispatch}) => {
      await dispatch('fetchOwn')
      await dispatch('fetchManaged')
    },
  },
  mutations: {
    setMade: (state, requests) => state.made = arrayToMap(requests),
    setProcessed: (state, requests) => state.managed.processed = arrayToMap(requests),
    setPending: (state, requests) => state.managed.pending = arrayToMap(requests),
  },
  getters: {
    my: state => Object.values(state.made).sort(sortRequests),
    myPending: state => Object.values(state.made).filter(r => !r.status).sort(sortRequests),
    myProcessed: state => Object.values(state.made).filter(r => r.status).sort(sortRequests),
    processed: state => Object.values(state.managed.processed).sort(sortRequests),
    pending: state => Object.values(state.managed.pending).sort(sortRequests),
    getById: state => id => ({...state.made, ...state.managed.processed, ...state.managed.pending}[id]),
    countPending: state => Object.keys(state.managed.pending).length,
  },
}
